import { useLocalStorage } from '@vueuse/core';

export function useAantalBerichten() {
  const aantal = useLocalStorage('MENU_APP_AANTAL_BERICHTEN', 0);

  return { aantal };
}
